import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_TERMINATION,
  DELETE_TERMINATION,
  UPDATE_TERMINATION,
  ADD_NEW_TERMINATION,
} from "./actionType";

import {
  getTerminationSuccess,
  getTerminationFail,
  deleteTerminationSuccess,
  deleteTerminationFail,
  updateTerminationSuccess,
  updateTerminationFail,
  addTerminationSuccess,
  addTerminationFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  approveTerminationApi,
  getTerminationApi,
  updateTerminationApi,
  deleteTerminationApi,
  addNewTerminationApi
} from "../../helpers/backend_helper";

function* getTermination({ payload: termination }) {
  try {
    const response = yield call(getTerminationApi, termination);
    yield put(getTerminationSuccess(GET_TERMINATION, response.data));
  } catch (error) {
    yield put(getTerminationFail(GET_TERMINATION, error));
  }
}

function* onUpdateTermination({ payload: termination }) {
  try {
    if (termination.setApprove) {
      const response = yield call(approveTerminationApi, termination);
      yield put(updateTerminationSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updateTerminationApi, termination);
      yield put(updateTerminationSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateTerminationFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteTermination({ payload: termination }) {
  try {
    const response = yield call(deleteTerminationApi, termination);
    yield put(deleteTerminationSuccess({ termination, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteTerminationFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewTermination({ payload: termination }) {
  try {
    const response = yield call(addNewTerminationApi, termination);
    yield put(addTerminationSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addTerminationFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetTermination() {
  yield takeEvery(GET_TERMINATION, getTermination);
}

export function* watchUpdateTermination() {
  yield takeEvery(UPDATE_TERMINATION, onUpdateTermination);
}

export function* watchDeleteTermination() {
  yield takeEvery(DELETE_TERMINATION, onDeleteTermination);
}

export function* watchAddNewTermination() {
  yield takeEvery(ADD_NEW_TERMINATION, onAddNewTermination);
}

function* terminationSaga() {
  yield all([
    fork(watchGetTermination),
    fork(watchDeleteTermination),
    fork(watchUpdateTermination),
    fork(watchAddNewTermination)
  ]);
}

export default terminationSaga;
